import * as React from 'react';

import { Box, Stack } from '@/components/layout';
import { cn } from '@/lib/utils';

type LogoProps = {
    className?: string;
    size?: '80x80' | '40x40' | '16x16';
};

export function Logo({ className, size = '80x80' }: LogoProps) {
    const sizeClasses = {
        '80x80':
            'size-[80px] text-[33px] p-2 group-data-[collapsible=icon]:size-[40px] group-data-[collapsible=icon]:text-[16px] group-data-[collapsible=icon]:p-1',
        '40x40': 'size-[40px] text-[16px] p-2',
        '16x16': 'size-[16px] text-[6px] p-1',
    };

    return (
        <Box
            className={cn(
                'flex items-center justify-center',
                'border-primary rounded-sm border-solid',
                'border-4 group-data-[collapsible=icon]:border-2',
                'box-border',
                sizeClasses[size],
                className,
            )}
        >
            <Stack className="text-foreground justify-center font-sans leading-[0.98] font-black whitespace-pre">
                <p className="mb-0">Pay</p>
                <p>Dirt</p>
            </Stack>
        </Box>
    );
}
